import { SCHOOL_LOGOS_LOADING, SCHOOL_LOGOS_ERROR, SCHOOL_LOGOS_SUCCESS } from "./type";
const initState = {
    loading: true,
    error: false,
    profiles: [],
};

const schoolLogosReducer = (state = initState, action) => {
    switch (action.type) {
        case SCHOOL_LOGOS_LOADING:
            return { ...state, loading: true };
        case SCHOOL_LOGOS_ERROR:
            return { ...state, loading: false, error: true };
        case SCHOOL_LOGOS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                logos: action.payload.rows,
                totalCount: action.payload.count,
            };
        default:
            return state;
    }
};

export { schoolLogosReducer };